import React, { useState } from "react";
import Flatpickr from "react-flatpickr";
import "@core/scss/react/libs/flatpickr/flatpickr.scss";

const FormInputDateComponent = ({
  label,
  id,
  name,
  value,
  placeholder,
  error,
  onChange,
  isVertical,
  isRequired = false,
  isTimeEnabled = false,
  isDisabled = false,
}) => {
  const handleDateChange = (selectedDates, dateStr, instance) => {
    // // console.log(selectedDates, dateStr, instance);
    if (onChange) onChange(dateStr);
  };
  return (
    <div className="col-12">
      <div className="row mb-1">
        <div className={isVertical ? "col-sm-12" : "col-sm-2"}>
          <label className="col-form-label">
            {label} {isRequired && <> * </>}
          </label>
        </div>
        <div className={isVertical ? "col-sm-12" : "col-sm-10"}>
          <Flatpickr
            id="default-picker"
            name={name}
            className="form-control"
            value={value}
            onChange={(selectedDates, dateStr, instance) =>
              handleDateChange(selectedDates, dateStr, instance)
            }
            options={{ enableTime: isTimeEnabled }}
            dateFormat="YYYY-MM-DD"
            placeholder={placeholder}
            disabled={isDisabled}
          />
          {error && <div className="invalid-feedback">{error}</div>}
        </div>
      </div>
    </div>
  );
};

export default FormInputDateComponent;
